/*
 *  I10DIAEFCOLI18n.ts
 *
 *  Created by Node Generator on Sun Aug 10 2025 19:21:38 GMT+0200 (Central European Summer Time)
 *  Copyright © 2025 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

export default {
  I10DIAEFCOL_SECTION_0_TITLE: "Calculez le diamètre d'une canalisation d'eau froide collective",
  I10DIAEFCOL_coeffMajoration: '',
  I10DIAEFCOL_SECTION_1_TITLE: '',
  I10DIAEFCOL_in_evier: 'Evier',
  I10DIAEFCOL_in_lavabo: 'Lavabo',
  I10DIAEFCOL_in_bidet: 'Bidet',
  I10DIAEFCOL_in_baignoire: 'Baignoire',
  I10DIAEFCOL_in_douche: 'Douche',
  I10DIAEFCOL_in_robinetdemi: 'Robinet 1/2',
  I10DIAEFCOL_in_robinetquart: 'Robinet 3/4',
  I10DIAEFCOL_in_lavemain: 'Lave mains',
  I10DIAEFCOL_in_baclaver: 'Bac à laver',
  I10DIAEFCOL_in_linge: 'Machine à laver le linge',
  I10DIAEFCOL_in_vaiselle: 'Machine à laver la vaisselle',
  I10DIAEFCOL_res_S: 'Simultanéité',
  I10DIAEFCOL_SECTION_2_TITLE: '',
  I10DIAEFCOL_res_debitBase: 'Débit de base',
  I10DIAEFCOL_res_coeffSimul: 'Coéfficient de simultanéité',
  I10DIAEFCOL_res_debitProbable: 'Débit probable',
  I10DIAEFCOL_res_diamIntRecommande: 'Diamètre recommandé',
  I10DIAEFCOL_SECTION_3_TITLE: 'Choix conduite',
  I10DIAEFCOL_tube_uuid: 'Diamètre intérieur :',
  I10DIAEFCOL_res_debit_max_prob: 'Débit maximum probable',
  I10DIAEFCOL_res_vitesseReelle: 'Vitesse réelle',
  I10DIAEFCOL_res_vitesseSilMax: 'Vitesse silencieuse maximum',
  I10DIAEFCOL_canalisationdebit_uuid: '',
  I10DIAEFCOL_res_diamConforme: 'Diamètre non conforme',
  I10DIAEFCOL_COEFFICIONT_MAJORATION: 'Coefficient de majoration'
}
